import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import NavigationUtil from 'utils/NavigationUtil';
import ActiveIndicatorEnum from 'utils/device/ActiveIndicatorEnum';
import DeviceLinksUtil from 'utils/device/DeviceLinksUtil';
import DateFormatter from 'utils/date/DateFormatter';
import templateHtml from 'templates/navigation/DevicesPopupMenuItemView.html';

var Events = {
    ON_NAVIGATION: 'ON_NAVIGATION',
    ON_ACTIVITY_TRACKER_CHANGE: 'ON_ACTIVITY_TRACKER_CHANGE',
    ON_SYNC_MESSAGE_REMOVE: 'ON_SYNC_MESSAGE_REMOVE'
};

var DevicesPopupMenuItemView = Backbone.View.extend({
    template: _.template(templateHtml),

    events: {
        'click .js-device-link': 'navigateLink',
        'click .sync-item-title': 'navigateLink',
        'click .js-set-as-activity-tracker': 'onSetActivityTrackerLinkClicked',
        'click .new-items-alert': 'onNewItemsBulletClick',
        'click .sync-item-list-toggle a': 'onSyncItemDetailsClick',
        'click .sync-item-remove': 'onSyncItemRemoveClick',
        'click .sync-item-remove-confirm .btn-keep': 'hideConfirmationPopup',
        'click .sync-item-remove-confirm .btn-confirm': 'onRemovePopupConfirmClick'
    },

    className: 'header-nav-menu-section',

    initialize: function(args) {
        this.device = args.device;
        this.messages = args.messages;
        this.trackerCount = args.trackerCount;
        this.isRetired = args.isRetired;
        this.isPrimaryTrainingDevice = args.isPrimaryTrainingDevice;
        this.isPrimaryWearableDevice = args.isPrimaryWearableDevice;
        this.enableAppStoreWebLink = args.enableAppStoreWebLink;
    },

    render: function() {
        this.$el.html(
            this.template({
                Localizer: Localizer,
                device: this.device.toJSON(),
                deviceUrl: NavigationUtil.url(this.getDeviceUrl()),
                enableAppStoreWebLink: this.enableAppStoreWebLink,
                appStoreUrl: this.device.get('appSupport') ? DeviceLinksUtil.getAppStoreUrl(this.device) : null,
                ActiveIndicatorEnum: ActiveIndicatorEnum,
                url: NavigationUtil.url,
                isRetired: this.isRetired,
                showBatteryLow: this.device.get('batteryLow') || false,
                DateFormatter: DateFormatter,
                isPrimaryTrainingDevice: this.isPrimaryTrainingDevice,
                isPrimaryWearableDevice: this.isPrimaryWearableDevice,
                shouldShowFirmwareUpdateAwareness: this.shouldShowFirmwareUpdateAwarenessBanner()
            })
        );

        if (this.trackerCount > 1 && (this.device.get('wellness') || this.device.get('hybrid'))) {
            this.renderActiveActivityTracker();
        }

        return this;
    },

    shouldShowFirmwareUpdateAwarenessBanner: function() {
        return (
            this.device.get('applicationKey') === 'IndexSmartScale2' &&
            this.device.get('isPrimaryUser') === true &&
            this.device.get('currentFirmwareVersion') < 300
        );
    },

    /**
     * Remove the messages that have isGroupChild === true and return the length of the remaining messages
     */
    getMessageCount: function() {
        return _.reject(this.messages, function(message) {
            return message.isGroupChild;
        }).length;
    },

    renderActiveActivityTracker: function() {
        if (
            !this.device.get('primaryActivityTrackerIndicator') &&
            this.device.get('activeInd') !== ActiveIndicatorEnum.NOT_ACTIVE
        ) {
            this.$('.js-active-activity-tracker').hide();
            this.$('.js-set-as-activity-tracker').show();
        } else if (this.device.get('activeInd') !== ActiveIndicatorEnum.NOT_ACTIVE) {
            this.$('.js-active-activity-tracker').show();
            this.$('.js-set-as-activity-tracker').hide();
        }
        if (
            this.device.get('applicationKey').indexOf('HRM') >= 0 ||
            this.device.get('applicationKey').indexOf('edge') >= 0
        ) {
            this.$('.js-set-as-activity-tracker').hide();
        }
    },

    onSetActivityTrackerLinkClicked: function(e) {
        e.preventDefault();
        this.trigger(Events.ON_ACTIVITY_TRACKER_CHANGE, this.device);
    },

    onSyncItemDetailsClick: function(e) {
        e.preventDefault();

        this.$(e.currentTarget)
            .closest('.sync-item-content')
            .find('.sync-item-list')
            .slideToggle();
    },

    onSyncItemRemoveClick: function(e) {
        e.preventDefault();

        var messageName = '<strong>' + $(e.currentTarget).data('messageName') + '</strong>',
            messageId = $(e.currentTarget).data('messageId'),
            groupName = $(e.currentTarget).data('groupName');

        this.$('.sync-item-remove-confirm')
            .show()
            .find('.confirm-text')
            .html(Localizer.localize('connections.page.stop.follower.prompt', messageName))
            .end()
            .find('.btn-confirm')
            .data('messageId', messageId)
            .data('groupName', groupName);
    },

    onRemovePopupConfirmClick: function(e) {
        var messageId = $(e.currentTarget).data('messageId'),
            messageGroupName = $(e.currentTarget).data('groupName'),
            message = $(e.currentTarget).data('message');

        this.trigger(Events.ON_SYNC_MESSAGE_REMOVE, messageId, messageGroupName, message);
    },

    hideMessageItem: function(messageId, removeGroup, callback) {
        var onRemoveSlideComplete = function(callback) {
            return function() {
                this.remove();
                if (callback) callback();
            };
        };

        if (removeGroup) {
            $('.sync-item.sync-item-' + messageId)
                .parent()
                .closest('.sync-item')
                .slideUp(400, onRemoveSlideComplete(callback));
        } else {
            this.$('.sync-item.sync-item-' + messageId).slideUp(400, onRemoveSlideComplete(callback));
        }
    },

    updateMessagesCount: function() {
        var messageCount = this.getMessageCount(),
            $el = this.$('.new-items-alert');

        if (messageCount > 0) {
            $el.html(messageCount);

            if (messageCount === 1) {
                $el.attr('title', Localizer.localize('item_to_sync'));
            } else {
                $el.attr('title', Localizer.localize('items_to_sync', messageCount));
            }
        } else {
            $el.remove();
            this.$('.sync-item-remove-confirm').remove();
            this.$('.sync-list').remove();
        }
    },

    hideConfirmationPopup: function() {
        this.$('.sync-item-remove-confirm').hide();
    },

    onNewItemsBulletClick: function() {
        this.$('.sync-list').slideToggle(200);
    },

    getDeviceUrl: function() {
        return '/device/' + this.device.get('deviceId');
    },

    navigateLink: function(e) {
        if (!e.ctrlKey && !e.metaKey) {
            e.preventDefault();
        }

        this.trigger(Events.ON_NAVIGATION);
        NavigationUtil.anchorTagHandler(e);
    }
});

DevicesPopupMenuItemView.Events = Events;
export default DevicesPopupMenuItemView;
